import { postApi } from "../apiCall";

export const getAuditPaymentLogs = ({ entityId, entityType, fromDate, toDate }) => {
  const url = `${process.env.REACT_APP_API_URL}/payments/audit/payment`;
  return postApi(url, { entityId, entityType, fromDate, toDate });
};

export const getAuditListingLogs = ({ entityId, entityType, fromDate, toDate }) => {
  const url = `${process.env.REACT_APP_API_URL}/bsbp/audit/listing`;
  return postApi(url, { entityId, entityType, fromDate, toDate });
};

export const getAuditListingDetail = ({ capacityId, entityType }) => {
  const url = `${process.env.REACT_APP_API_URL}/bsbp/audit/listing/detail`;
  return postApi(url, { capacityId, entityType });
};

export const getAuditContract = ({ contractUniqueId }) => {
  const url = `${process.env.REACT_APP_API_URL}/bsbp/audit/contract`;
  return postApi(url, { contractUniqueId });
};
